import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
export default function ToggleDrawer({ anchor, isOpen, onClose, drawerWidth, content }) {
  return (
    <Drawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
    >
      <Box sx={{ width: drawerWidth }}>
        {content}
      </Box>
    </Drawer>
  );
}